import { combineReducers } from "redux";
import Product from "./reducer/productReducer";

const reducers = {
  Product,
};
export const rootReducer = combineReducers(reducers);
